import styled from "styled-components"

export const StyledSticky = styled.div<{ position: "top" | "bottom"; isSticky: boolean }>`
  position: sticky;
  top: ${({ position }) => (position === "top" ? 0 : undefined)};
  bottom: ${({ position }) => (position === "bottom" ? 0 : undefined)};
  background-color: white;
  transition: box-shadow 0.1s;
  box-shadow: ${({ position, isSticky }) =>
    isSticky ? `0 ${position === "top" ? "3px" : "-3px"} 3px rgba(0, 0, 0, 0.05)` : undefined};
  z-index: 1;
`
